import React from 'react';
import util from 'Utils/commonUtil';

// Components
import Anchor from 'Components/common/Anchor';

// Icons
import { Menu } from '@material-ui/icons';

class Navigation extends React.Component {
    scrollTop = 0;
    scrollLeft = 0;
    state = {
        opened: false,
        maskClassName: { 'navigation-mask': true }
    }

    componentWillMount() {
        this.navigationMask = React.createRef();
    }

    componentDidMount() {
        const navigationMask = this.navigationMask.current;

        window.addEventListener('resize', this.setPosition);
        window.addEventListener('scroll', this.setPosition);

        util.isAndroid() && navigationMask.addEventListener('touchstart', ev => {
            const startTouchPointY = ev.touches[0].clientY;

            function touchmove(ev) {
                const currentTouchPointY = ev.touches[0].clientY;
                const scrollTopMax = navigationMask.scrollHeight - navigationMask.offsetHeight;

                if(startTouchPointY > currentTouchPointY && navigationMask.scrollTop <= 0) {
                    ev.preventDefault();
                }
                else if(startTouchPointY < currentTouchPointY && navigationMask.scrollTop >= scrollTopMax){
                    ev.preventDefault();
                }
            }

            function touchend() {
                navigationMask.removeEventListener('touchmove', touchmove);
                navigationMask.removeEventListener('touchend', touchend);
            }

            navigationMask.addEventListener('touchmove', touchmove);
            navigationMask.addEventListener('touchend', touchend);
        });

        document.getElementsByTagName('body')[0].appendChild(navigationMask);
    }

    componentWillUnmount() {
        const navigationMask = this.navigationMask.current;
        document.getElementsByTagName('body')[0].removeChild(navigationMask);

        window.removeEventListener('resize', this.setPosition);
        window.removeEventListener('scroll', this.setPosition);
        if(this.state.opened) this.setBodyStyle(false);
    }

    handleOpen = () => {
        const { opened } = this.state;

        this.setBodyStyle(!opened);

        this.setState({
            opened: !opened,
            maskClassName: {
                'navigation-mask': true,
                'is-open': !opened ? true : false,
                'is-close': !opened ? false : true
            }
        });
    }

    clickBg = () => {
        this.setBodyStyle(false);

        this.setState({
            opened: false,
            maskClassName: {
                'navigation-mask': true,
                'is-close': true
            }
        })
    }

    setPosition = () => {
        const navigationMask = this.navigationMask.current;
        const { top, left } = util.getScrollPos();

        navigationMask.top = top + 'px';
        navigationMask.left = left + 'px';
    }

    setBodyStyle(opened) {
        const body = document.getElementsByTagName('body')[0];
        const { top, left } = util.getScrollPos();

        if(opened) {
            this.scrollTop = top;
            this.scrollLeft = left;

            if(window.disabledBodyScroll) window.disabledBodyScroll++;
            else window.disabledBodyScroll = 1;

            if(util.isPhone() && !util.isAndroid()) {
                body.style.width = '100%';
                body.style.height = '100%';
                body.style.position = 'fixed';
                body.style.left = -left + 'px';
                body.style.top = -top + 'px';
            }
            else {
                body.style.overflow = 'hidden';
            }
        }
        else {
            if(window.disabledBodyScroll) window.disabledBodyScroll--;
            if(window.disabledBodyScroll) return;

            if(util.isPhone() && !util.isAndroid()) {
                body.style.width = 'auto';
                body.style.height = 'auto';
                body.style.position = 'static';
                util.setScrollPos({ top: this.scrollTop, left: this.scrollLeft });
            }
            else {
                body.style.overflow = 'visible';
            }
        }
    }

    cloneNavigationItem = (item, index) => {
        if(!item) return null;

        const childProps = item.props;
        const newProps = {
            ...childProps,
            key: index,
            onClickOfSingleTap: () => {
                this.handleOpen();
                if(util.isFunction(childProps.onClickOfSingleTap)) {
                    childProps.onClickOfSingleTap();
                }
            }
        };

        if(!childProps || util.isString(item.type) || new item.type().name !== 'NavigationItem') {
            return item;
        }

        return React.cloneElement(item, newProps);
    }

    render() {
        const { maskClassName } = this.state;
        const { scrollTop, scrollLeft } = this;
        let children = [];
        let maskClassNameList = util.getClassName(maskClassName).split(' ');

        if(this.props.className) maskClassNameList = [...maskClassNameList, ...this.props.className.split(' ')]

        if(this.props.children) {
            children = util.isArray(this.props.children) ? this.props.children : [this.props.children];
        }

        return (
            <React.Fragment>
                <Anchor onClickOfSingleTap={ this.handleOpen }><Menu/></Anchor>
                <div { ...util.clickOfSingleTap(this.clickBg) }
                    ref={ this.navigationMask }
                    style={{ top: scrollTop + 'px', left: scrollLeft + 'px' }}
                    className={ maskClassNameList.join(' ') }>
                    <div { ...util.clickOfSingleTap(null, { isStopPropagation: true }) } className="navigation-container">
                        { children && children.map(this.cloneNavigationItem) }
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Navigation;
